
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'
import { i18n } from '@/i18n'

const getDefaultState = () => {
  return {
    paginationInfo: {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: null,
    order: null,
    filters: [],
    masterFilters: {
      name: { label: i18n.t('clients.name'), value: '' },
      codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
      ns: { label: i18n.t('clients.ns'), value: '' },
      partner: { label: i18n.t('clients.partner'), value: '' },
      grupoVigilante: { label: i18n.t('clients.grupo_vigilante'), value: '', labelValue: '' },
      tipoServicio: { label: i18n.t('clients.service_type'), value: '' },
      activo: { label: i18n.t('companies.active'), value: '' },
      codPGNMultiple: { label: 'Sedes', value: '' },
      moduloMultiple: { label: 'Módulos', value: '' },
    },
    notUseLikeTags: ['results', 'page', 'sort', 'order', 'status'],
    kendo: {
      columns: [
        { field: 'selected', width: '50px', minResizableWidth: 50, headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
        { field: 'IdEmpresa', width: '100px', minResizableWidth: 50, title: i18n.t('clients.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
        {
          field: 'Distribuidor',
          title: i18n.t('distributors.distributor'),
          columnMenu: 'myTemplate',
          hidden: true,
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        { field: 'Nombre', width: '300px', minResizableWidth: 225, title: i18n.t('clients.name'), columnMenu: 'myTemplate', locked: false },
        { field: 'EmailsContacto', width: '300px', minResizableWidth: 225, title: i18n.t('clients.EmailsContacto'), columnMenu: 'myTemplate', locked: false },
        { field: 'CodigoExterno', width: '300px', minResizableWidth: 225, title: i18n.t('clients.cod_ext'), columnMenu: 'myTemplate', locked: false },
        { field: 'NumeroSerieEmpresa', width: '300px', minResizableWidth: 225, title: i18n.t('clients.ns'), columnMenu: 'myTemplate', locked: false },
        { field: 'Partner', width: '150px', minResizableWidth: 100, title: i18n.t('clients.partner'), columnMenu: 'myTemplate', locked: false },
        { field: 'GrupoVigilante', width: '240px', minResizableWidth: 180, title: i18n.t('clients.grupo_vigilante'), columnMenu: 'myTemplate', locked: false },
        { field: 'MesesUserPass', width: '390px', minResizableWidth: 195, title: i18n.t('clients.mesesUserPass'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'TipoServicio', width: '150px', minResizableWidth: 100, title: i18n.t('clients.service_type'), columnMenu: 'myTemplate', locked: false },
        { field: 'Activo', title: i18n.t('companies.active'), minResizableWidth: 50, hidden: true, columnMenu: 'myTemplate', width: '100px', locked: false, cell: 'checkboxTemplate' },
        { field: 'FechaAlta', width: '200px', minResizableWidth: 150, title: i18n.t('clients.fecha_alta'), columnMenu: 'myTemplate', locked: false, hidden: false, type: 'date', filter: 'date', format: '{0:dd-MM-yyyy}' },
        { field: 'NumeroNotificacionesAnuales', width: '300px', minResizableWidth: 225, title: i18n.t('distributors.num_neos'), columnMenu: 'myTemplate', locked: false, hidden: false },
        { field: 'EspacioTotal', width: '300px', minResizableWidth: 225, title: i18n.t('clients.stored_space'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'NumeroSedes', width: '200px', minResizableWidth: 100, title: i18n.t('clients.num_locations'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'NumeroCIFEmpresas', width: '200px', minResizableWidth: 100, title: i18n.t('clients.num_companies'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'NumeroSedesxCIFEmpresas', width: '250px', minResizableWidth: 125, title: i18n.t('clients.num_pgncif'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'NumeroUsuarios', width: '200px', minResizableWidth: 100, title: i18n.t('clients.num_users'), columnMenu: 'myTemplate', locked: false, hidden: true }, 
        { field: 'FaseConfiguracion', width: '225px', minResizableWidth: 168, title: i18n.t('clients.fase_config'), columnMenu: 'myTemplate', locked: false, hidden: false }, 
        { field: 'PaqueteContratacion', width: '250px', minResizableWidth: 188, title: i18n.t('clients.paquete_contratacion'), columnMenu: 'myTemplate', locked: false, hidden: false }, 
        { field: 'FechaFacturacion', width: '200px', minResizableWidth: 150, title: i18n.t('clients.alta_fact'), type: 'date', filter: 'date', format: '{0:dd-MM-yyyy HH:mm}', columnMenu: 'myTemplate', locked: false },
        { field: 'TipoHSM', width: '200px', minResizableWidth: 120, title: i18n.t('clients.tipo_hsm'), columnMenu: 'myTemplate', locked: false, hidden: false },
        { field: 'TipoCliente', width: '200px', minResizableWidth: 120, title: i18n.t('clients.tipo_cliente'), columnMenu: 'myTemplate', locked: false, hidden: false },
        { field: 'FechaMigracionSolpheo', width: '300px', minResizableWidth: 180, title: i18n.t('clients.fecha_migracion_solpheo'), type: 'date', filter: 'date', format: '{0:dd-MM-yyyy}', columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'MaquinasNuestras', width: '200px', minResizableWidth: 120, title: i18n.t('clients.maquinas_nuestras'), columnMenu: 'myTemplate', locked: false, hidden: true, filter: 'boolean' },
      ],
      skip: 0,
      take: 10,
      sortable: true,
      sort: [],
      group: [],
      reorderable: true,
      groupable: true,
      filter: null,
      columnMenu: true,
      dataResult: null,
      navigate: true
    },
  }
}

const state = getDefaultState()

const getters = {
  getKendo: state => state.kendo,
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value, item.labelValue])
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.filters = data
    return data
  }
}

const mutations = {
  setKendoColumns (state, data) {
    data.unshift('selected')
    state.kendo.columns = state.kendo.columns.map(x => {
      if (data.includes(x.field)) {
        x.hidden = false
      } else {
        x.hidden = true
        data.push(x.field)
      }
      return x
    }).sort((a, b) => data.indexOf(a.field) - data.indexOf(b.field))
  },
  setKendo (state, kendo) {
    state.kendo = kendo
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  resetStateWithoutSort (state, data) {
    Object.assign(state, getDefaultState())
    // Object.assign(state, getDefaultState())
    state.kendo.sort = data.sort
    state.kendo.group = data.group
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      // Modificado para objetos multiples con valor obligatario
      if (item[1].value !== '' && item[1].value?.valor !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
    // console.log(data)
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      name: { label: i18n.t('clients.name'), value: '' },
      codigoExterno: { label: i18n.t('clients.cod_ext'), value: '' },
      ns: { label: i18n.t('clients.ns'), value: '' },
      partner: { label: i18n.t('clients.partner'), value: '' },
      grupoVigilante: { label: i18n.t('clients.grupo_vigilante'), value: '', labelValue: '' },
      tipoServicio: { label: i18n.t('clients.service_type'), value: '' },
      activo: { label: i18n.t('companies.active'), value: '' },
      codPGNMultiple: { label: 'Sedes', value: '' },
      moduloMultiple: { label: 'Módulos', value: '' },
    }
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  }
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
  resetStateWithoutSort ({ commit, rootGetters }) {
    const data = {
      sort: rootGetters['clientsPersisted/getSort'],
      group: rootGetters['clientsPersisted/getGroup'],
    }
    commit('resetStateWithoutSort', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
